export { default } from './VideoSection';



// WEBPACK FOOTER //
// ./src/components/templates/VideoSection/index.js